import * as React from 'react';

function SvgNewZealand(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.776 0v.99L13.83 2.96h3.945v2.963H13.83l3.945 1.973v1.049h-1.877l-5.533-2.767v2.767H7.402V6.178L1.87 8.945H0V20.73h35.537V0H17.776zM0 5.924v1.968l3.937-1.968H0zM10.366 0v2.712L15.783 0h-5.417zM1.986 0l5.417 2.712V0H1.986zM0 2.961h3.937L0 .995V2.96z"
        fill="#1A237B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.77 0l-5.924 2.96H10.52L16.443 0h-.66l-5.417 2.712V0h-.594V3.555h8.004V2.96h-3.944L17.776.99V0h-.007zM7.403 0v2.712L1.986 0H.001l5.922 2.96H4.598L.001.665v.332L3.938 2.96H0v.594H7.997V0h-.594zM11.986 5.332H9.772v3.613h.594V6.177l5.533 2.768H17.777v-.057l-5.93-2.964h1.323l4.607 2.303v-.33L13.83 5.924h3.946v-.592h-5.791zM7.107 5.332H0v.592h3.937L0 7.892v.991l5.922-2.96h1.324l-6.04 3.023h.663l5.533-2.769v2.769h.594V5.332h-.89z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.923 5.924L0 8.884v.062h1.207l6.04-3.022H5.923zM0 0v.664l4.598 2.297h1.326L0 0zM16.443 0l-5.924 2.96h1.327L17.77 0h-1.326zM11.846 5.924l5.93 2.964v-.66L13.17 5.924h-1.324z"
        fill="#BD0034"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.997 0V3.555H0v1.777H7.996v3.613h1.776V5.332h8.004V3.554H9.772V0H7.997z"
        fill="#BD0034"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.669 6.05h.963l.301-.918.299.918h.962l-.78.569.298.918-.779-.569-.784.569.3-.918-.78-.569z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.097 6.19h.638l.199-.606.195.607h.637l-.514.374.195.61-.513-.377-.518.376.197-.609-.516-.374z"
        fill="#BD0034"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.804 9.938h.964l.301-.92.299.92h.965l-.78.565.296.92-.78-.568-.78.567.297-.919-.782-.565z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.233 10.076h.638l.198-.607.197.607h.64l-.517.375.197.609-.517-.378-.517.378.199-.609-.518-.375z"
        fill="#BD0034"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.117 8.974h.86l.267-.817.265.817h.857l-.693.502.266.818-.695-.504-.697.505.267-.819-.697-.502z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.499 9.097h.57l.175-.541.175.541h.57l-.46.335.174.54-.459-.334-.46.334.177-.54-.462-.335z"
        fill="#BD0034"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.528 16.035H25.6l.333-1.02.33 1.02h1.073l-.867.633.33 1.02-.866-.63-.867.63.33-1.02-.868-.633z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.004 16.192h.71l.22-.676.218.676h.708l-.572.417.22.676-.574-.418-.574.418.22-.676-.576-.418z"
        fill="#BD0034"
      />
    </svg>
  );
}

export default SvgNewZealand;
